<template>
  <div class="p-tiptapEditor">
    <tiptap-vuetify v-model="editorContent" :extensions="extensions" />
  </div>
</template>

<script>
import {
  // component
  TiptapVuetify,
  // extensions
  Heading,
  Bold,
  Italic,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Table,
  TableCell,
  TableHeader,
  TableRow
} from 'tiptap-vuetify'

export default {
  name: 'TipTapEditor',
  components: { TiptapVuetify },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data: () => ({
    extensions: [
      History,
      [
        Heading,
        {
          options: {
            levels: [2, 3, 4]
          }
        }
      ],
      Blockquote,
      Link,
      Underline,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      Bold,
      HorizontalRule,
      Paragraph,
      HardBreak,
      Table,
      TableCell,
      TableHeader,
      TableRow
    ]
  }),
  computed: {
    editorContent: {
      get () {
        return this.$props.content
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>

<style scoped></style>
